import { Box } from '@mui/material';

export interface BrandedSplashProps {
  /** Logo image source — pass each app's own logo (Ari Chat or Ari Cloud). */
  logoSrc: string;
  /** Full-bleed background colour. Defaults to the auth-dark surface. */
  bgcolor?: string;
  /** Logo width in px. */
  logoWidth?: number;
}

/**
 * Full-screen branded boot splash: a centered logo with a slow opacity pulse on
 * a dark surface. Shared by ari + ari-cloud (each passes its own logo) so the
 * hand-off to login or the app reads as one surface instead of a bare spinner.
 * Neutral on purpose — not a login skeleton, which would flash for already
 * authenticated users.
 */
export function BrandedSplash({ logoSrc, bgcolor = '#0B0A12', logoWidth = 132 }: BrandedSplashProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100dvh',
        backgroundColor: bgcolor,
      }}
    >
      <Box
        component="img"
        src={logoSrc}
        alt=""
        aria-hidden
        sx={{
          width: logoWidth,
          '@keyframes ariSplashPulse': {
            '0%, 100%': { opacity: 0.4 },
            '50%': { opacity: 0.85 },
          },
          animation: 'ariSplashPulse 1.4s ease-in-out infinite',
          '@media (prefers-reduced-motion: reduce)': { animation: 'none', opacity: 0.8 },
        }}
      />
    </Box>
  );
}
